<section class="sh-dialog__content">
  @if (complexFieldDefinition.Children; as childFields) {
    <dl class="sh-description-list sh-clear-margin">
      @for (childField of childFields; track childField) {
        @if (isSimpleType(childField)) {
          <ng-container
            [ngTemplateOutlet]="simpleField"
            [ngTemplateOutletContext]="{fieldDefinition: childField, value: complexValue}"
            >
          </ng-container>
        }
        @if (isListType(childField)) {
          <ng-container
            [ngTemplateOutlet]="listField"
            [ngTemplateOutletContext]="{fieldDefinition: childField, value: complexValue}"
            >
          </ng-container>
        }
        @if (isMapType(childField)) {
          <ng-container
            [ngTemplateOutlet]="mapField"
            [ngTemplateOutletContext]="{fieldDefinition: childField, value: complexValue}"
            >
          </ng-container>
        }
        @if (isComplexListType(childField)) {
          <ng-container
            [ngTemplateOutlet]="complexListField"
            [ngTemplateOutletContext]="{fieldDefinition: childField, value: complexValue}"
            >
          </ng-container>
        }
      }
    </dl>
  }
</section>

<ng-template #simpleField let-fieldDefinition="fieldDefinition" let-value="value">
  <dt [id]="fieldDefinition.FlatKey" class="sh-description-list__term">{{ fieldDefinition.Label }}</dt>
  <dd class="sh-description-list__details">{{ getSimpleValue(fieldDefinition, value) }}</dd>
</ng-template>

<ng-template #listField let-fieldDefinition="fieldDefinition" let-value="value">
  <dt [id]="fieldDefinition.FlatKey" class="sh-description-list__term">{{ fieldDefinition.Label }}</dt>
  <dd class="sh-description-list__details">
    @if (getListValues(fieldDefinition, value); as labels) {
      @for (label of labels; track label; let index = $index) {
        <span>
          {{ label }}
          @if (index < labels.length-1) {
            ,
          }
        </span>
      }
    }
  </dd>
</ng-template>

<ng-template #mapField let-fieldDefinition="fieldDefinition" let-value="value">
  <dt [id]="fieldDefinition.FlatKey" class="sh-description-list__term">{{ fieldDefinition.Label }}</dt>
  <dd class="sh-description-list__details">
    <sh-html-parser [message]="getMapValue(fieldDefinition, value)"></sh-html-parser>
  </dd>
</ng-template>

<ng-template #complexListField let-fieldDefinition="fieldDefinition" let-value="value">
  <dt [id]="fieldDefinition.FlatKey" class="sh-description-list__term">{{ fieldDefinition.Label }}</dt>
  <dd class="sh-description-list__details">
    <ul class="sh-label-list sh-clear-margin">
      @for (label of getComplexListValues(fieldDefinition, value); track label) {
        <li class="sh-label-list__item">
          <span class="sh-label-list__item__label">
            <sh-html-parser [message]="label"></sh-html-parser>
          </span>
        </li>
      }
    </ul>
  </dd>
</ng-template>
